import React from 'react';
import { NextSeo } from 'next-seo';
import MainLayout from '@views/layouts/main-layout';
import BreadcrumbComponent from '@views/components/breadcrumb/Breadcrumb';
import Quotation from '@views/modules/quotation';
import { HOST } from '@lib/helpers';

export const QuotationPage = (): JSX.Element => {
  const breadcrumb = (
    <BreadcrumbComponent
      options={[
        {
          name: 'Báo giá',
          active: true,
        },
      ]}
    />
  );

  return (
    <MainLayout breadcrumb={breadcrumb}>
      <NextSeo
        title="Báo giá văn phòng phẩm sỉ & lẻ mới nhất"
        canonical={`${HOST}/bao-gia`}
        description="Báo giá văn phòng phẩm mới nhất chính hãng, đa dạng mặt hàng, chiết khấu cao lên đến 15%, Fast giao văn phòng phẩm miễn phí nội thành TPHCM siêu tốc."
      />
      <h1>Báo giá văn phòng phẩm sỉ & lẻ mới nhất | Fast</h1>
      <Quotation />
    </MainLayout>
  );
};

export default QuotationPage;
